export const obtenerValorEnNotacionCientifica = (valor, minExp = -5, decimales = 1) => {
    try {
        return (valor < Math.pow(10, minExp)) ? valor.toExponential(decimales) : valor.toFixed(5);
    }
    catch (error) {
        return 0;
    }
}